export default __webpack_public_path__ + "static/media/wannalisn_logo.560b327d.png";